const inline = (s) => s.split(/(\*\*[^*]+\*\*)/g).map((p, i) => (p.startsWith("**") && p.endsWith("**") ? <strong key={i} className="text-white">{p.slice(2, -2)}</strong> : p));

export const Markdown = ({ text, testid }) => {
  const blocks = [];
  text.split("\n").forEach((line) => {
    const t = line.trim();
    if (!t) return;
    const bullet = /^[-*•]\s+/.test(t) || /^\d+\.\s+/.test(t);
    const last = blocks[blocks.length - 1];
    if (bullet) {
      const item = t.replace(/^([-*•]|\d+\.)\s+/, "");
      if (last?.type === "ul") last.items.push(item); else blocks.push({ type: "ul", items: [item] });
    } else blocks.push({ type: t.startsWith("#") ? "h" : "p", text: t.replace(/^#+\s*/, "") });
  });
  return (
    <div className="grid gap-2 text-sm leading-relaxed text-slate-300" data-testid={testid}>
      {blocks.map((b, i) => b.type === "ul"
        ? <ul key={i} className="grid gap-1 list-disc pl-5">{b.items.map((x, j) => <li key={j}>{inline(x)}</li>)}</ul>
        : b.type === "h" ? <p key={i} className="font-semibold text-white">{inline(b.text)}</p> : <p key={i}>{inline(b.text)}</p>)}
    </div>);
};
